module.exports = __webpack_public_path__ + "img/whatsapp-alert.6ad07122.png";